import { ArrowBack, EnhancedEncryption, LockClock } from "@mui/icons-material";
import { Button, Card, CardContent, CircularProgress, Grid2, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { BASE_URL } from "../url";
import theme from "./theme";

const GradientBackground = styled(Grid2)({
    alignItems    : "center",
    justifyContent: "center",
    height        : "100vh",
    background    : theme.palette.primary.main,
});

const StyledCard = styled(Card)({
    padding        : "10%",
});

const StyledBox = styled(Grid2)({
    display        : "flex",
    alignItems     : "center",
    paddingBottom  : "10vh",
});

const GradientButton = styled(Button)({
    background  : theme.palette.primary.main,
    color       : "#fff",
    fontWeight  : "bold",
    boxShadow   : "none"
});

const ChangePassword = () => {
    const navigate = useNavigate();
    const [oldPass, setOldPass]  = useState('');
    const [newPass, newPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const changePassword = (e: any) => {
        e.preventDefault();
        setLoading(true);
        const token = JSON.parse(localStorage.getItem("token") || '{}');
        fetch(`${window.location.protocol}//${BASE_URL}/dashboard/change-password`, {
            method : 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token.access_token}`
            },
            body   : JSON.stringify({password: oldPass, new_password: newPass})
        })
        .then(async res => (
            res.status === 200? Swal.fire({
                title: 'Password Changed',
                confirmButtonColor: theme.palette.primary.main,
            }).then(() => {
                localStorage.removeItem('token')
                navigate('/login')
                return null;
            }): Swal.fire({
                title: 'Invalid Credentials',
                text : 'Please provide valid password',
                confirmButtonColor: theme.palette.primary.main,
            })
        ))
        .finally(() => setLoading(false))
    }

    return (
        <GradientBackground container>
            <Grid2 size={12}>
                <IconButton sx={{color: 'whitesmoke', mx: 2}} onClick={() => navigate('/dashboard')}>
                    <ArrowBack/> Go back
                </IconButton>
            </Grid2>
            <StyledBox>
                <motion.div
                    initial    = {{ opacity: 0, y: -20 }}
                    animate    = {{ opacity: 1, y: 0 }}
                    transition = {{ duration: 1 }}
                >
                    <StyledCard>
                        <CardContent>
                            <Typography variant="h4" align="center" sx={{my: 2}}>
                                Change Password
                            </Typography>
                            <form onSubmit={changePassword}>
                                <TextField fullWidth
                                    label     = "Current Password"
                                    type      = "password"
                                    margin    = "normal"
                                    variant   = "outlined"
                                    value     = {oldPass}
                                    onChange  = {e => setOldPass(e.target.value)}
                                    slotProps = {{input: {
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <LockClock color="primary" />
                                            </InputAdornment>
                                        ),
                                    }}}
                                />
                                
                                <TextField fullWidth
                                    label     = "New Password"
                                    type      = "password"
                                    margin    = "normal"
                                    variant   = "outlined"
                                    value     = {newPass}
                                    onChange  = {e => newPassword(e.target.value)}
                                    slotProps = {{input: {
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <EnhancedEncryption color="primary" />
                                            </InputAdornment>
                                        ),
                                    }}}
                                />
                                
                                <GradientButton fullWidth
                                    type    = "submit"
                                    variant = "contained"
                                    color   = "secondary"
                                    sx      = {{ mt: 2 }}
                                    disabled = {loading}
                                >
                                    {loading? <CircularProgress size="24px" color="inherit" />: 'Submit'}
                                </GradientButton>
                            </form>
                        </CardContent>
                    </StyledCard>
                </motion.div>
            </StyledBox>
        </GradientBackground>
    );
}

export default ChangePassword;